import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  Optional,
} from "@angular/core";
import { ModalComponent } from "../modal/modal.component";
import { CampaignService } from "@services/campaign.service";
import { ProductService } from "@services/product.service";
import { TitleModalConfig } from "@shared/title-modal-config";
import { Router } from "@angular/router";
import { Events } from "@app/enums/events.enum";
@Component({
  selector: "app-common-modal-coverage-and-exclusions",
  templateUrl: "./common-modal-coverage-and-exclusions.component.html",
  styleUrls: ["./common-modal-coverage-and-exclusions.component.scss"],
})
export class CommonModalCoverageAndExclusionsComponent implements OnInit {
  @Output() closeEvent = new EventEmitter<any>();
  campaignData;
  campaignAdditionalData;
  plansCount;
  planInfo;
  productInfo;
  productCoverages;
  productExclusions;
  productAssists;
  moreInfoConfig = null;
  constructor(
    @Optional() public parentComponentInjectionObject: ModalComponent,
    private campaignService: CampaignService,
    private productService: ProductService,
    public titleConfig: TitleModalConfig,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.planInfo = this.titleConfig?.data;
    this.campaignData = this.campaignService.getData();
    this.campaignAdditionalData = this.campaignService.getAdditionalData();
    this.productInfo = this.productService.getProductByName(
      this.campaignData?.product_id ||
        this.titleConfig.data.productName ||
        "HOSPIA"
    );
    this.plansCount = this.productInfo.benefitLevels.length;
    this.productCoverages = this.productService.getJustCoveragesByProduct(
      this.campaignData?.product_id ||
        this.titleConfig.data.productName ||
        "HOSPIA"
    );
    this.productExclusions = this.productService.getJustExclusionsByProduct(
      this.campaignData?.product_id ||
        this.titleConfig.data.productName ||
        "HOSPIA"
    );
    this.productAssists =
      this.productService.getAssistsByProduct(
        this.campaignData?.product_id || this.titleConfig?.data?.productName,
        this.titleConfig.data.name
      ) || [];
  }
  isArray(obj: any) {
    return Array.isArray(obj);
  }
  replaceStr(targetStr) {
    if (
      this.campaignAdditionalData?.make &&
      this.campaignAdditionalData?.model
    ) {
      const strOutput = `${
        this.campaignAdditionalData.make[0]
      }${this.campaignAdditionalData.make.slice(1).toLowerCase()} ${
        this.campaignAdditionalData.model
      }`;
      return targetStr.replaceAll("**replaceText**", strOutput);
    }
    return targetStr.replaceAll("**replaceText**", "celular");
  }
  openScheduleDialog($event) {
    $event.preventDefault();
    this.parentComponentInjectionObject.closeModalFromDynContainer({
      message: Events.ScheduleSpaceCallEvent,
    });
  }
  closeDialog() {
    this.parentComponentInjectionObject.closeDialog();
  }

  openMoreInfoCTA($event, config) {
    $event.preventDafault();
    this.router.navigateByUrl(config.url);
    this.parentComponentInjectionObject.closeDialog();
  }
  toggleAccordion($event, covEx, covin) {
    this.productExclusions.coverages[covin].viewMore.opened =
      !this.productExclusions.coverages[covin].viewMore.opened;
  }
  toggleAsisAccordion($event, asin) {
    this.productInfo.coverageData.list[asin].viewMore.opened =
      !this.productInfo.coverageData.list[asin].viewMore.opened;
  }
  toggleCovAccordion($event, covin) {
    this.productCoverages[covin].viewMore.opened =
      !this.productCoverages[covin].viewMore.opened;
  }
  toggleAssistsAccordion($event, asis) {
    this.productAssists[asis].viewMore.opened =
      !this.productAssists[asis].viewMore.opened;
  }
}
